<!-- Adapted from SPlayer 40d9ec6 Discover/toplists.vue and Card/SongListCard.vue (AGPL-3.0). -->
<template>
  <div class="discover-toplists" :aria-busy="loading">
    <template v-if="official.length">
      <h2>官方榜</h2>
      <div class="official-list">
        <router-link v-for="item in official" :key="item.id" class="song-data-card" :to="{ name: 'playlist', params: { id: String(item.id) } }">
          <SaltCard class="song-data-surface">
          <div class="title"><strong class="name">{{ item.name }}</strong><span class="desc">{{ item.updateFrequency }}</span></div>
          <div class="content"><div class="cover"><img :src="item.coverImgUrl || item.picUrl || fallback" alt="" loading="lazy" @error="fallbackImage" /></div>
            <div class="info"><div v-for="(song, index) in (item.tracks || []).slice(0, 3)" :key="index" class="song-item"><span>{{ index + 1 }}. {{ song.first || song.name }}</span><small>{{ song.second }}</small></div><p v-if="!item.tracks || !item.tracks.length">{{ item.description || '打开榜单查看歌曲' }}</p></div>
          </div>
          </SaltCard>
        </router-link>
      </div>
    </template>
    <template v-if="selected.length"><h2>{{ official.length ? '精选榜' : '排行榜' }}</h2><CoverList :items="selected" type="playlist" /></template>
    <FeedStatus :loading="loading" :error="error" :count="items.length" empty-text="来源暂未返回排行榜。" @retry="loadFeed(false)" />
  </div>
</template>
<script>
import { runtime } from '../../bridge';
import catalogFeed from './catalog-feed';
import CoverList from './CoverList.vue';
import FeedStatus from './FeedStatus.vue';
import SaltCard from '../ui/SaltCard.vue';
export default {
  name: 'SPlayerDiscoverToplists', mixins: [catalogFeed], components: { CoverList, FeedStatus, SaltCard },
  data() { return { catalogSettings: runtime.catalogSettings, fallback: runtime.cover() }; },
  computed: {
    feedKey() { return this.catalogSettings.platform; },
    official() { return this.items.filter(item => item.ToplistType !== undefined); },
    selected() { return this.items.filter(item => item.ToplistType === undefined); },
  },
  methods: {
    async fetchFeed() { const data = await runtime.catalog('charts', undefined, { platform: this.catalogSettings.platform }); return { items: data.charts, more: false }; },
    fallbackImage(event) { if (event.target.src !== this.fallback) event.target.src = this.fallback; },
  },
};
</script>
<style scoped>
h2 { margin:16px 0 8px; font-size:14px; font-weight:500; }
.official-list { display: grid; grid-template-columns: repeat(auto-fill, minmax(270px, 1fr)); gap: 16px; }
.song-data-card { display:flex; flex-direction:column; min-width:0; color:inherit; text-decoration:none; }
.song-data-surface { height:100%; }
.song-data-surface ::v-deep .salt-ui-card { padding:12px 16px; height:100%; }
.song-data-card:hover { opacity:.8; }
.title { display: flex; align-items: center; justify-content: space-between; gap: 8px; margin-bottom: 10px; }
.name { font-size:14px; font-weight:500; }
.desc { font-size: 12px; color: var(--salt-subtext, var(--color-secondary)); }
.content { display: flex; min-width: 0; gap: 14px; }
.cover { width: 85px; height: 85px; flex-shrink: 0; border-radius: 6px; overflow: hidden; }
img { width: 100%; height: 100%; object-fit: cover; }
.info { display: flex; flex: 1; min-width: 0; flex-direction: column; justify-content: space-evenly; gap: 5px; }
.info p { margin: 0; font-size: 12px; line-height: 1.5; display: -webkit-box; -webkit-box-orient: vertical; -webkit-line-clamp: 3; overflow: hidden; color: var(--salt-subtext, var(--color-secondary)); }
.song-item { overflow:hidden; text-overflow:ellipsis; white-space:nowrap; font-size:14px; }
.song-item small { margin-left: 6px; color: var(--salt-subtext, var(--color-secondary)); }
@container (max-width: 440px) { .official-list { grid-template-columns: minmax(0, 1fr); } }
</style>
